import { initContract } from '@ts-rest/core';
import { publicFeedbackContract } from './feedback.public.contract';

const c = initContract();

export const feedbackContract = c.router(
  {
    public: publicFeedbackContract,
  },
  {
    pathPrefix: '/feedback',
    strictStatusCodes: true,
  }
);

export * from './feedback.public.contract';
export * from './models';
